// import slider1 from './slider-images/slider1.mp4'
import slider1 from './slider-images/banner4.jpg'
import slider2 from './slider-images/banner5.jpg'
import slider3 from './slider-images/banner6.JPG'


export const sliderItems = [
    {
      id: 1,
      img: slider1,
      title: "Step Into Style:",
      subtitle: "Your ultimate fashion destination",
      desc: "Medical World Co., Ltd, founded in 2015, is a manufacturing and distribution company of uniforms and accessories.",
      bg: "f5fafd",
    },
    {
      id: 2,
      img: slider2,
      title: "Professional Excellence:",
      subtitle: "Trusted by Thousands",
      desc: "Join thousands of satisfied customers who rely on our premium products for their professional needs.",
      bg: "fcf1ed",
    },
    {
      id: 3,
      img: slider3,
      title: "Quality Products:",
      subtitle: "Premium Uniforms & Accessories",
      desc: "Discover our extensive collection of high-quality uniforms and accessories, designed for comfort and durability.",
      bg: "f5fafd",
    },
  ];

  export const categories = [
    {
      id: 1,
      img: "https://images.pexels.com/photos/5886041/pexels-photo-5886041.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      title: "Family Arrow",
      cat: "woman"
    },
    {
      id: 2,
      img: "https://images.pexels.com/photos/2983464/pexels-photo-2983464.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      title: "Korea Style",
      cat: "man"
    },
    {
      id: 3,
      img: "https://images.pexels.com/photos/5480696/pexels-photo-5480696.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      title: "Polo Towel",
      cat: "tshirt"
    },
  ];

  export const popularProducts = [
    {
      id:1,
      name:"product1",
      img:"https://d3o2e4jr3mxnm3.cloudfront.net/Mens-Jake-Guitar-Vintage-Crusher-Tee_68382_1_lg.png",
    },
    
    {
      id:3,
      name:"product3",
      img:"https://www.prada.com/content/dam/pradanux_products/U/UCS/UCS319/1YOTF010O/UCS319_1YOT_F010O_S_182_SLF.png",
    },
    {
      id:4,
      name:"product4",
      img:"https://www.burdastyle.com/pub/media/catalog/product/cache/7bd3727382ce0a860b68816435d76e26/107/BUS-PAT-BURTE-1320516/1170x1470_BS_2016_05_132_front.png",
    },
    {
      id:5,
      name:"product5",
      img:"https://images.ctfassets.net/5gvckmvm9289/3BlDoZxSSjqAvv1jBJP7TH/65f9a95484117730ace42abf64e89572/Noissue-x-Creatsy-Tote-Bag-Mockup-Bundle-_4_-2.png",
    },
    {
      id:6,
      name:"product6",
      img:"https://d3o2e4jr3mxnm3.cloudfront.net/Rocket-Vintage-Chill-Cap_66374_1_lg.png",
    },
   
    {
      id:8,
      name:"product8",
      img:"https://www.pngarts.com/files/3/Women-Jacket-PNG-High-Quality-Image.png",
    },
  ]